import React from "react";
import {
  FaCalendarAlt,
  FaChevronLeft,
  FaChevronRight,
  FaLayerGroup,
  FaMapMarkerAlt,
  FaRedo,
} from "react-icons/fa";
import { cn } from "../utils/attendancePageUtils";

const AttendanceFiltersBar = ({
  dojos = [],
  filteredGroups = [],
  selectedDojo = "",
  selectedGroup = "",
  attendanceDate = "",
  onChangeDojo,
  onChangeGroup,
  onChangeDate,
  onPreviousDay,
  onNextDay,
  onReset,
  disabled = false,
}) => {
  return (
    <section className="mt-6 rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
        <div className="grid flex-1 gap-4 lg:grid-cols-3">
          <div>
            <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-200">
              <FaMapMarkerAlt className="text-blue-600 dark:text-blue-400" />
              Lieu
            </label>
            <select
              value={selectedDojo}
              onChange={(e) => onChangeDojo(e.target.value)}
              disabled={disabled}
              className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-100 disabled:cursor-not-allowed disabled:bg-slate-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:focus:border-blue-400 dark:focus:ring-blue-500/20 dark:disabled:bg-slate-800"
            >
              <option value="">Sélectionner un lieu</option>
              {dojos.map((dojo) => (
                <option key={dojo.id} value={dojo.id}>
                  {dojo.nom_dojo}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-200">
              <FaLayerGroup className="text-purple-600 dark:text-purple-400" />
              Groupe
            </label>
            <select
              value={selectedGroup}
              onChange={(e) => onChangeGroup(e.target.value)}
              disabled={disabled || !selectedDojo}
              className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-100 disabled:cursor-not-allowed disabled:bg-slate-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:focus:border-blue-400 dark:focus:ring-blue-500/20 dark:disabled:bg-slate-800"
            >
              <option value="">Sélectionner un groupe</option>
              {filteredGroups.map((group) => (
                <option key={group.id} value={group.id}>
                  {group.nom_groupe}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-200">
              <FaCalendarAlt className="text-amber-600 dark:text-amber-400" />
              Date
            </label>
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={onPreviousDay}
                disabled={disabled}
                className="inline-flex h-[50px] w-[50px] items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:bg-slate-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700 dark:disabled:bg-slate-800"
              >
                <FaChevronLeft />
              </button>

              <input
                type="date"
                value={attendanceDate}
                onChange={(e) => onChangeDate(e.target.value)}
                disabled={disabled}
                className="min-w-0 flex-1 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-100 disabled:cursor-not-allowed disabled:bg-slate-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:focus:border-blue-400 dark:focus:ring-blue-500/20 dark:disabled:bg-slate-800"
              />

              <button
                type="button"
                onClick={onNextDay}
                disabled={disabled}
                className="inline-flex h-[50px] w-[50px] items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:bg-slate-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700 dark:disabled:bg-slate-800"
              >
                <FaChevronRight />
              </button>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-3">
          <button
            type="button"
            onClick={() => onChangeDate(new Date().toISOString().split("T")[0])}
            disabled={disabled}
            className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-800 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:bg-slate-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700 dark:disabled:bg-slate-800"
          >
            Aujourd’hui
          </button>

          <button
            type="button"
            onClick={onReset}
            disabled={disabled}
            className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-800 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:bg-slate-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700 dark:disabled:bg-slate-800"
          >
            <FaRedo />
            Réinitialiser
          </button>
        </div>
      </div>

      {dojos.length > 0 && (
        <div className="mt-5">
          <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
            Accès rapide · lieux
          </p>
          <div className="flex flex-wrap gap-2">
            {dojos.map((dojo) => (
              <button
                key={dojo.id}
                type="button"
                onClick={() => onChangeDojo(String(dojo.id))}
                className={cn(
                  "rounded-full border px-4 py-2 text-sm font-semibold transition",
                  String(selectedDojo) === String(dojo.id)
                    ? "border-blue-600 bg-blue-600 text-white dark:border-blue-500 dark:bg-blue-500"
                    : "border-slate-200 bg-white text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                )}
              >
                {dojo.nom_dojo}
              </button>
            ))}
          </div>
        </div>
      )}

      {selectedDojo && filteredGroups.length > 0 && (
        <div className="mt-5">
          <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
            Accès rapide · groupes
          </p>
          <div className="flex flex-wrap gap-2">
            {filteredGroups.map((group) => (
              <button
                key={group.id}
                type="button"
                onClick={() => onChangeGroup(String(group.id))}
                className={cn(
                  "rounded-full border px-4 py-2 text-sm font-semibold transition",
                  String(selectedGroup) === String(group.id)
                    ? "border-purple-600 bg-purple-600 text-white dark:border-purple-500 dark:bg-purple-500"
                    : "border-slate-200 bg-white text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                )}
              >
                {group.nom_groupe}
              </button>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default AttendanceFiltersBar;